import React from "react";
import cn from "classnames";
import Checkbox from "../../Checkboxes/BaseCheckbox";
import styles from "./SearchFilterButton.module.scss";

interface SearchFilterCheckboxProps {
    label: string
    checked?: boolean
    onChange: (e?: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Search Filter Button
 */
const SearchFilterCheckbox: React.FC<SearchFilterCheckboxProps> = (
    props: SearchFilterCheckboxProps
) => {
    const {
        label,
        onChange,
        checked = false
    } = props;

    return (
        <div
            className={cn(styles.button, styles.checkboxButton)}
            color="white"
        >
            <span className={styles.labelContainer}>
                <span className={styles.checkboxBody}>
                    <label
                        htmlFor="checkbox-field"
                        className={styles.labelTitle}
                    >
                        <span className={styles.flexRowContainer}>
                            <span>
                                {label}
                            </span>

                            <Checkbox checked={checked} inputId="checkbox-field" labelText="" onChange={onChange} />
                        </span>
                    </label>
                </span>
            </span>
        </div>
    );
};

export { SearchFilterCheckbox as default };
export type { SearchFilterCheckboxProps };
